<template functional>
  <v-col md="4">
    <strong>{{ props.title }}</strong>
    <ul class="mt-3 pa-0">
      <li
        v-for="listItem in props.list"
        :key="listItem.label"
      >
        <v-icon
          small
          :color="listItem.color"
          class="mr-1"
        >
          {{ listItem.icon }}
        </v-icon>
        {{ listItem.label }}
      </li>
    </ul>
  </v-col>
</template>

<script>
export default {
  name: 'contents-calculator-help-text-col',
  props: {
    title: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
  },
};
</script>
